import { sosPublicDetailApi } from "api/sos";
import { useNotificationContext } from "contexts/NotificationContext";
import { ISosLocation, ISosPublicDetail } from "models/sos";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function useSosTracking() {
  const { showError } = useNotificationContext();
  const id: string = useParams().id!;
  const [clearCronjob, setClearCronjob] = useState<boolean>(false);
  const [currentLocation, setCurrentLocation] = useState<{
    defaultCenter: { lat: number; lng: number };
  }>({
    defaultCenter: {
      lat: 13.496494229233356,
      lng: 39.47494624044569,
    },
  });
  const [location, setLocation] = useState<ISosLocation | null>(null);
  const [data, setData] = useState<ISosPublicDetail>();
  const [trackerCronjob, setTrackerCronjob] = useState<NodeJS.Timer>();

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((value) => {
        if (value?.coords?.latitude && value?.coords?.longitude)
          setCurrentLocation({
            defaultCenter: {
              lat: value.coords.latitude,
              lng: value.coords.longitude,
            },
          });
      });
    }
    const temp = setInterval(fetchData, 10000);
    setTrackerCronjob(temp);
    fetchData();

    return () => {
      try {
        if (trackerCronjob) clearInterval(trackerCronjob);
        if (temp) clearInterval(temp);
      } catch (error) {}
    };
  }, []); // eslint-disable-line

  useEffect(() => {
    if (clearCronjob) clearInterval(trackerCronjob);
  }, [clearCronjob]); // eslint-disable-line

  const fetchData = async () => {
    const { data, error } = await sosPublicDetailApi(id);
    if (data) {
      data.locations.sort(
        (a, b) =>
          new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
      );
      setData((prev) => {
        if ((prev === undefined || prev === null) && data.locations.length > 0)
          setCurrentLocation({
            defaultCenter: {
              lat: data.locations[0].latitude,
              lng: data.locations[0].longitude,
            },
          });
        return { ...data };
      });
      if (data.locations.length > 0) {
        data.locations.sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
        setCurrentLocation({
          defaultCenter: {
            lat: data.locations[0].latitude,
            lng: data.locations[0].longitude,
          },
        });
      }
    } else {
      showError(error?.message ?? "");
      setClearCronjob(true);
    }
  };
  return { currentLocation, data, location, setLocation };
}
